export default {
  LOGIN: 'LOGIN',
  AUTH_TOKEN: 'AUTH_TOKEN',
  REMOVE_AUTH_TOKEN: 'REMOVE_AUTH_TOKEN',
};
